import { render, staticRenderFns } from "./CallToActionSection.vue?vue&type=template&id=0c0cf952&scoped=true"
import script from "./CallToActionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CallToActionSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cf952",
  null
  
)

export default component.exports